export default __webpack_public_path__ + "static/media/IM.7ba7c084.svg";